var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "-2 -2 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    id: "Oval",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BFC7E0",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Back-Outline",
    transform: "translate(8 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 6.00073L3.33625 6.00073L7.19312 1.64113L7.19312 1.64113C7.56868 1.2159 7.50684 0.584682 7.055 0.231254C6.60316 -0.122176 5.93243 -0.0639783 5.55688 0.361242L0.244375 6.36069L0.244375 6.36069C0.208633 6.40841 0.176672 6.45855 0.14875 6.51068C0.14875 6.56068 0.14875 6.59067 0.074375 6.64067L0.074375 6.64067C0.0262156 6.75532 0.00099992 6.87736 1.04455e-09 7.00064L0 7.00064L1.40404e-08 7.00064C0.00100018 7.12392 0.026216 7.24596 0.0743757 7.3606C0.0743757 7.4106 0.0743757 7.4406 0.148751 7.49059L0.148751 7.49059C0.176673 7.54273 0.208634 7.59286 0.244376 7.64058L5.55688 13.64L5.55688 13.64C5.75913 13.8686 6.05898 14.0005 6.375 14L6.375 14C6.62325 14.0005 6.86384 13.9191 7.055 13.77L7.055 13.77C7.50674 13.4176 7.56934 12.7872 7.19482 12.3621C7.19426 12.3614 7.19369 12.3608 7.19312 12.3601L3.33625 8.00054L15.9375 8.00054L15.9375 8.00054C16.5243 8.00054 17 7.55287 17 7.00063C17 6.4484 16.5243 6.00073 15.9375 6.00073L15.9375 6.00073Z",
    transform: "translate(4 5)",
    id: "Path",
    fill: "#636E95",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.46a79bd4446a74bbeba0690d45bac27b.svg";
export { ForwardRef as ReactComponent };